import type { UserGroupsLocale } from './en'

export const userGroupsFrCa = {
  common: {
    cancel: `Annuler`,
    close: `Fermer`,
    delete: `Supprimer`,
    error: `Erreur`,
    yes: `Oui`,
    no: `Non`,
    requirePin: `Exiger un NIP`,
    pin: `NIP`,
    auto: `auto`,
  },
  list: {
    title: `Groupes d'utilisateurs`,
    searchPlaceholder: `Rechercher par nom ou membre...`,
    searchAriaLabel: `Rechercher des groupes d'utilisateurs`,
    createNew: `Nouveau groupe d'utilisateurs`,
    createNewAriaLabel: `Créer un nouveau groupe d'utilisateurs`,
    tableAriaLabel: `Tableau des groupes d'utilisateurs`,
    loading: `Chargement des groupes d'utilisateurs...`,
    noResultsTitle: `Aucun résultat trouvé`,
    noResultsDescription: `Essayez de modifier vos termes de recherche`,
    emptyTitle: `Aucun groupe d'utilisateurs pour le moment`,
    emptyDescription: `Commencez par créer votre premier groupe d'utilisateurs`,
    autoGeneratedDeleteTooltip: `Les groupes générés automatiquement ne peuvent pas être supprimés`,
    truncatedWarning: `Affichage des {{shown}} premiers groupes d'utilisateurs sur {{total}}. Certains groupes ne sont pas affichés — veuillez contacter le soutien technique.`,
    actionsForGroup: `Actions pour {{name}}`,
    editGroup: `Modifier {{name}}`,
    deleteGroup: `Supprimer {{name}}`,
    deleteGroupDisabled: `Supprimer {{name}} (désactivé)`,
    accessAria: `{{label}} : {{status}}`,
    column: {
      name: `Nom`,
      members: `Membres`,
      internal: `Interne`,
      local: `Local`,
      longDistance: `Longue dist.`,
      domesticLongDistance: `Longue distance`,
      international: `International`,
      action: `Action`,
    },
    pagination: {
      perPage: `Par page :`,
      total: `({{count}} au total)`,
      resultsPerPage: `Résultats par page`,
      previousPage: `Page précédente`,
      nextPage: `Page suivante`,
      jumpToPage: `Aller à la page {{page}}`,
      morePages: `Plus de pages`,
    },
    deleteDialog: {
      title: `Supprimer le groupe d'utilisateurs`,
      description: `Voulez-vous vraiment supprimer "{{name}}"? Cela supprimera toutes les associations de membres et ne pourra pas être annulé.`,
      successTitle: `Groupe d'utilisateurs supprimé`,
      successDescription: `"{{name}}" a été supprimé.`,
      alreadyDeletedTitle: `Déjà supprimé`,
      alreadyDeletedDescription: `Ce groupe d'utilisateurs est introuvable; il a peut-être déjà été supprimé.`,
      failedDescription: `Impossible de supprimer le groupe d'utilisateurs.`,
    },
  },
  form: {
    addTitle: `Ajouter un groupe d'utilisateurs`,
    editTitle: `Modifier le groupe d'utilisateurs`,
    loading: `Chargement du groupe d'utilisateurs...`,
    loadingError: `Erreur lors du chargement du groupe d'utilisateurs : {{message}}`,
    autoGeneratedNotice: `Groupe généré automatiquement - certains champs sont restreints.`,
    nameLabel: `Nom`,
    namePlaceholder: `Entrer le nom du groupe`,
    nameRequired: `Le nom est obligatoire.`,
    nameMaxLength: `Le nom doit contenir 64 caractères ou moins.`,
    accessPermissions: `Autorisations d'accès`,
    members: `Membres`,
    createUserGroup: `Créer le groupe d'utilisateurs`,
    saveChanges: `Enregistrer les modifications`,
    access: {
      internal: `Interne`,
      local: `Local`,
      domesticLongDistance: `Longue distance nationale`,
      international: `International`,
      tollNumbers: `Numéros payants`,
      maliciousAreaCodes: `Indicatifs régionaux malveillants`,
      superAccess: `Accès super`,
      eavesdropping: `Écoute`,
      promptRecording: `Enregistrement des messages vocaux`,
    },
    memberPicker: {
      placeholder: `Sélectionner des membres...`,
      searchPlaceholder: `Filtrer les membres...`,
      emptyLabel: `Aucun utilisateur n'est assigné à ce PBX.`,
      noResultsLabel: `Aucun utilisateur ne correspond à votre filtre.`,
      summary_one: `{{count}} membre sélectionné`,
      summary_other: `{{count}} membres sélectionnés`,
    },
  },
  toast: {
    createdTitle: `Groupe d'utilisateurs créé`,
    updatedTitle: `Groupe d'utilisateurs mis à jour`,
    authRequiredTitle: `Authentification requise`,
    authRequiredDescription: `Votre session a peut-être expiré. Veuillez vous réauthentifier et réessayer.`,
    createFailedTitle: `Échec de la création du groupe d'utilisateurs`,
    updateFailedTitle: `Échec de la mise à jour du groupe d'utilisateurs`,
  },
} satisfies UserGroupsLocale
